module.exports = __webpack_public_path__ + "img/编组 5.437c78c2.png";